// @mui
import Box from "@mui/material/Box";
// components
import { PagesHeader, PagesOutlet } from "./index";

export const PagesLayout = () => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        height: "100%",
        bgcolor: (theme) => theme.palette.background.default,
      }}
    >
      <PagesHeader />
      <PagesOutlet />
    </Box>
  );
};
